import Slider from 'react-slick';
import FeatureCarouselCard from '../../molecules/featureCarouselCard/FeatureCarouselCard';
import { setCarouselConfig } from '../../../utils/carousel';

export default function FeaturesCarousel({ config, content }) {
    const settings = setCarouselConfig(config);
    const colours = ['CardBlue', 'CardGreen', 'CardPink', 'CardBlueDark'];

    return (
        <div className={`oCarousel`}>
            <Slider {...settings}>
                {content?.map((feature, index) => {
                    return (
                        <FeatureCarouselCard
                            key={feature.id}
                            colour={colours[index]}
                            {...feature}
                        />
                    );
                })}
            </Slider>
            <style global jsx>{`
                .slick-slider {
                    max-width: 1920px;
                    margin: 0 auto;
                    overflow: hidden;
                }
                .slick-track {
                    overflow: auto;
                }
                .slick-slide {
                    transform: scale(0.8);
                    transition: 0.3s;
                    display: block;
                }
                .slick-slide.slick-center {
                    transform: scale(1);
                    transition: 0.3s;
                }
                .oCarousel .slick-list:after {
                    position: absolute;
                    content: '';
                    width: 20%;
                    height: 100%;
                    z-index: 5;
                    background: linear-gradient(
                        90deg,
                        #ffffff 49.74%,
                        rgba(255, 255, 255, 0) 81.09%
                    );
                    left: 0;
                    top: 0;
                }
                .oCarousel .slick-list:before {
                    position: absolute;
                    content: '';
                    width: 20%;
                    height: 100%;
                    z-index: 5;
                    background: linear-gradient(
                        270deg,
                        #ffffff 49.74%,
                        rgba(255, 255, 255, 0) 81.09%
                    );
                    right: 0;
                    top: 0;
                }
                .slick-slider button {
                    position: absolute;
                }
                .slick-dots {
                    list-style-type: none;
                    padding: 0;
                    margin: 30px 0 0;
                    display: block;
                    text-align: center;
                }
                .slick-dots li {
                    display: inline-block;
                    background-color: #dfe1e2;
                    width: 10px;
                    height: 10px;
                    border-radius: 10px;
                    margin-right: 5px;
                }
                .slick-dots li:last-child {
                    margin-right: 0;
                }
                .slick-dots li.slick-active {
                    background-color: #29b2ff;
                }
                .slick-dots li button {
                    opacity: 0;
                }
                .slick-arrow {
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    border: 0;
                    background-color: transparent;
                    text-indent: 400px;
                    overflow: hidden;
                    width: 50px;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                .slick-arrow.slick-next {
                    right: 2%;
                    background-image: url('./images/icon-arrow-right.svg');
                }
                .slick-arrow.slick-prev {
                    left: 2%;
                    background-image: url('./images/icon-arrow-left.svg');
                }
                @media (max-width: 767px) {
                    .slick-list:before {
                        display: none;
                    }
                    .slick-list:after {
                        display: none;
                    }
                }
            `}</style>
        </div>
    );
}
